module.exports = __webpack_public_path__ + "img/next.8775d30c.svg";